export const TransitionService = {
    TRANSITION_PROPERTIES: [
        'transition',
        'webkitTransition',
        'mozTransition',
    ],
    fadeIn(element) {
        // Debug point: Start fade-in animation
        const originalStyles = TransitionService.TRANSITION_PROPERTIES.map(prop => element.style.getPropertyValue(prop));
        const handleTransitionEnd = () => {
            // Debug point: Fade-in animation completed
            element.style.opacity = '';
            originalStyles.forEach((style, index) => {
                const prop = TransitionService.TRANSITION_PROPERTIES[index];
                element.style.setProperty(prop || '', style);
            });
        };
        element.addEventListener('transitionend', handleTransitionEnd, { once: true });
        TransitionService.TRANSITION_PROPERTIES.forEach((prop) => {
            element.style.setProperty(prop, 'opacity 1s');
        });
        element.style.opacity = '1';
    },
};
//# sourceMappingURL=transition.service.js.map